import { AppBar, styled, Toolbar, alpha, Stack } from "@mui/material";
import { Link } from "react-scroll";

const DRAWER_WIDTH = 0;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 64;

export const AppBarStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  background: "none",
}));

export const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  backdropFilter: "blur(7px)",
  WebkitBackdropFilter: "blur(7px)",
  backgroundColor: alpha(theme.palette.background.paper, 0.6),
  borderRadius: "20px",
  marginTop: "10px",
  boxShadow: theme.customShadows.z8,
  // [theme.breakpoints.up("lg")]: {
  //   minHeight: APPBAR_DESKTOP,
  //   padding: theme.spacing(0, 5),
  // },
}));

export const StackStyle = styled(Stack)((theme) => ({}));

export const NavbarLink = styled(Link)(({ theme }) => ({
  backgroundColor: "transparent",
  padding: `${theme.spacing(2.5)} ${theme.spacing(4)}`,
  textAlign: "center",
  color: theme.palette.primary.main,
  borderRadius: "0",
  cursor: "pointer",
  borderBottom: `3px solid transparent`,
  fontWeight: 900,
  transition: ` ${theme.transitions.create(["color", "border"], {
    duration: theme.transitions.duration.standard,
  })}`,
  "&:hover": {
    color: theme.palette.secondary.main,
  },
  "&.active": {
    borderBottom: `3px solid  ${theme.palette.secondary.main} `,
    color: theme.palette.secondary.main,
  },
}));
